import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ContentUpdateCategory } from 'src/app/interfaces/content-update-category.interface';
import { ContentUpdatesCategoryService } from 'src/app/services/content-updates-category.service';

@Component({
    selector: 'app-add-edit-content-updates-categories',
    templateUrl: './add-edit-content-updates-categories.component.html',
    styleUrls: ['./add-edit-content-updates-categories.component.scss'],
    standalone: false
})
export class AddEditContentUpdatesCategoriesComponent implements OnInit {

	errorMsg = '';
	processing = false;
	form: any;
	errors: any;

	constructor(
		private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
		private contentUpdatesCategoryService: ContentUpdatesCategoryService,
		private dialogRef: MatDialogRef<AddEditContentUpdatesCategoriesComponent>,
	) {

		this.form = this.fb.group(this.data.record ? this.editForm() : this.addForm());
		this.processing = false;
	}

	getSlug(text: any) {
		const slugtxt = text.target.value.toLowerCase()
             .replace(/[^\w ]+/g, '')
             .replace(/ +/g, '-');
		this.form.get('slug').setValue(slugtxt);
	}

	ngOnInit(): void { }

	addForm() {
		return {
			title: ['', Validators.required],
			slug: ['', Validators.required],
			meta_title: [''],
			meta_description: ['']
		};
	}
	editForm() {
		return {
			title: [this.data.record.title, Validators.required],
			slug: [this.data.record.slug, Validators.required],
			meta_title: [this.data.record.meta_title],
			meta_description: [this.data.record.meta_description]
		};
	}

	submitForm(event: any) {
		event.preventDefault();
		if (!this.form.valid) return;

		this.processing = true;
		const contentUpdateCategory = this.form.value as ContentUpdateCategory;

		if (this.data.record) contentUpdateCategory.id = this.data.record.id;
		this.contentUpdatesCategoryService.storeOrUpdate(contentUpdateCategory)
			.subscribe((res: any) => {
				this.dialogRef.close(res.status);
			},
				(errorResponse: HttpErrorResponse) => {
					this.errors = errorResponse.error['errors'];
					if (this.errors.errors) {
						for (let key in this.errors.errors) {
							if (this.form.controls[key]) {
								this.form.controls[key].setErrors({ 'incorrect': true });
							}
						}
					}
					this.processing = false;
				});
	}

}
